import { APP_TOKEN } from '@/constant';
import { getServerApi } from '@/gql';
import { TaskTemplateUse } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useEffect, useState } from 'react';

export interface UseGetUserTaskTemplateUseResult {
    userTaskTemplateUse: TaskTemplateUse[] | null;
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<void>;
}

export const useGetUserTaskTemplateUse =
    (): UseGetUserTaskTemplateUseResult => {
        const [userTaskTemplateUse, setUserTaskTemplateUse] = useState<
            TaskTemplateUse[] | null
        >(null);
        const [loading, setLoading] = useState(false);
        const [error, setError] = useState<Error | null>(null);
        const { userId } = user;

        const getUserTaskTemplateUse = async () => {
            if (!userId) return;

            try {
                setLoading(true);
                setError(null);
                const api = getServerApi();
                const response = await api.getUserTaskTemplatesUse({
                    appToken: APP_TOKEN,
                });
                if (
                    response?.getUserTaskTemplatesUse?.data &&
                    response?.getUserTaskTemplatesUse?.success
                ) {
                    setUserTaskTemplateUse(
                        response.getUserTaskTemplatesUse.data,
                    );
                }
            } catch (err) {
                console.error('Failed to fetch user task template use:', err);
                setError(
                    err instanceof Error
                        ? err
                        : new Error('Failed to fetch user task template use'),
                );
            } finally {
                setLoading(false);
            }
        };

        useEffect(() => {
            getUserTaskTemplateUse();
        }, [userId]);

        return {
            userTaskTemplateUse,
            loading,
            error,
            refetch: getUserTaskTemplateUse,
        };
    };
